"use strict";require('@ebay/skin/lightbox-dialog');